/* jshint esversion: 6 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/homeMain",
    component: () => import("../views/home.vue"),
    children: [
      {
        path: "/practice",
        name: "practice",
        component: () => import("../views/center/home-center"),
      },
      {
        path: "/homeMain",
        name: "homeMain",
        meta:{
          name:'首页'
        },
        component: () => import("../views/center/home-main"),
      },
      // 新闻
      // news-center
      {
        path: "/news",
        name: "news",
        meta:{
          name:'新闻'
        },
        component: () => import("../views/center/news-center"),
      },
      {
        path:'/newsInfo',
        name: "newsInfo",
        component: () => import("../views/center/news-info.vue"),
      },
      {
        path: "/examination",
        name: "examination",
        redirect: "/examCenter",
        component: () => import("../views/center/examination"),
        children: [
          {
            path: "/examCenter",
            name: "examCenter",
            meta:{
              name:'考试中心'
            },
            component: () => import("../views/center/examination-center"),
          },
          {
            path: "/examCenterV2",
            name: "examCenterV2",
            component: () => import("../views/center/examination-centerV2"),
          },
          // examination-centerV2
          {
            path: "/examInfo",
            name: "examInfo",
            meta:{
              name:'比赛详情'
            },
            component: () => import("../views/center/examination-info"),
          },
          {

            path: "/account",
            meta:{
              name:'选择科目'
            },
            name: "account",
            component: () => import("../views/center/exmination-account"),
          },
          {

            path: "/information",
            meta:{
              name:'考试信息'
            },
            name: "information",
            component: () => import("../views/center/examination-information"),
          },

          {
            path: "/accountV2",
            name: "accountV2",
            redirect: "/info",
            component: () => import("../views/center/account-center"),
            children: [
              {
                path: "/info",
                name: "info",
                component: () => import("../views/center/account-info"),
              },
              {
                path: "/exam",
                name: "exam",
                component: () => import("../views/center/account-exam"),
              },
              {
                path: "/wrong",
                name: "wrong",
                component: () => import("../views/center/account-wrong"),
              },
              {
                path: "/vip",
                name: "vip",
                redirect: "/payinfo",
                component: () => import("../views/center/account-vip"),
                children: [
                  {
                    path: "/payinfo",
                    name: "payinfo",
                    component: () => import("../components/payinfo.vue"),
                  },
                  {
                    path: "/payment",
                    name: "payment",
                    component: () => import("../components/payment.vue"),
                  },
                ],
              },
              {
                path: "/order",
                name: "order",
                component: () => import("../views/center/account-order"),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("../views/register"),
  },
  {
    path: "/answer",
    name: "answer",
    component: () => import("../views/answer.vue"),
  },
  {
    path: "/analysis",
    name: "analysis",
    component: () => import("../views/analysis.vue"),
  },
  {
    path: "/answerOne",
    name: "answerOne",
    component: () => import("../views/answer-one.vue"),
  },
  {
    path: "/answerExam",
    name: "answerExam",
    component: () => import("../views/answer-exam.vue"),
  },
  {
    path: "/score",
    name: "score",
    component: () => import("../views/score.vue"),
  },

];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;

router.beforeEach((to, from, next) => {
  console.log(to)
  // 1.如果访问的是登录页面（无需权限），直接放行
  if (to.path === "/login" || to.path === "/homeMain" || to.path ==='/register' ||to.path ==='/info' || to.path ==='/news' ||to.path ==='/newsInfo'||to.path ==='/practice')
    return next();
  // 2.如果访问的是有登录权限的页面，先要获取token
  const tokenStr = localStorage.getItem("token");
  const isPerfect = localStorage.getItem("perfectInfo");
  // 2.1如果token为空，强制跳转到登录页面；否则，直接放行
  if (!tokenStr) {
      Vue.prototype.$message.error("请先登录");
      return next("/login");
  }
  if(isPerfect==='0'){
    Vue.prototype.$message.warning("请先完善个人信息");
    return next("/info");
  }
  next();
});
